import { VaultMorph } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function VaultMorphDemo() {
  return (
    <Section
      id="vault-morph"
      title="VaultMorph"
      description="A converge / transform delight animation: incoming item glyphs fly in from the left and resolve into a center anchor, on a loop while running. The on-brand depiction of items being converted into an experience (e.g. the sidebar Vault affordance while an experience is generating). running={false} or reduced motion renders the static resolved center only."
    >
      <VariantBlock label="Running" caption="default — document glyphs fly in and resolve into the AISquare mark on a loop">
        <VaultMorph running items={[{ id: "d1" }, { id: "d2" }, { id: "d3" }]} />
      </VariantBlock>

      <VariantBlock label="Sizes" caption="sm / md / lg">
        <div className="flex items-center gap-6">
          <VaultMorph size="sm" />
          <VaultMorph size="md" />
          <VaultMorph size="lg" />
        </div>
      </VariantBlock>

      <VariantBlock label="Static (idle)" caption="running={false} renders just the resolved center — also the reduced-motion fallback">
        <VaultMorph running={false} />
      </VariantBlock>
    </Section>
  );
}
